import './CookieMissing.scss'

import React from 'react'
import {useCookies} from '../../cookies/cookies'
import {useTranslation} from '../../util/i18n'
import {style} from '../../util/style'
import {CookieTheme} from './CookieTheme'

const styles = style('cookiemissing')

export const CookieMissing: React.FC<{
	cookie_services: Array<{id: number}>
}> = ({cookie_services}) => {
	const t = useTranslation('cookies')
	const {settings, setSettingsOpen} = useCookies()

	const notEnabledService = (cookie_services || [])
		.map(({id}) => settings.findServiceById(id))
		.find((service) => service && !service.enabled)

	if (!notEnabledService) return null

	return (
		<div className={styles()}>
			<CookieTheme.Wysiwyg>
				{notEnabledService.config.missing_consent}
			</CookieTheme.Wysiwyg>
			<CookieTheme.Button
				onClick={() => setSettingsOpen(true)}
				className={styles('button')}
				mod="outline"
			>
				{t.settings.title}
			</CookieTheme.Button>
		</div>
	)
}
